import React from "react";
import { useHistory } from "react-router-dom";
import { AppLayout } from "components/layouts/app-layout/app-layout";
import {
  NotFoundPrimaryButton,
  NotFoundSection,
  NotFoundSectionSecondary,
  NotFoundPageHeading,
  NotFoundEyebrowText,
  NotFoundBodyText,
} from "pages/global/styles/not-found.page.inline.styles";
export const NotFoundPage = () => {
  const history = useHistory();
  return (
    <AppLayout route="/not-found">
      <NotFoundSection>
        <NotFoundSectionSecondary>
          <NotFoundEyebrowText>Missing Route</NotFoundEyebrowText>
          <NotFoundPageHeading>404</NotFoundPageHeading>
          <NotFoundBodyText>
            The page you are looking for does not exist in this admin workspace. Use the navigation
            to return to a supported Athspire control screen.
          </NotFoundBodyText>
          <NotFoundPrimaryButton onClick={() => history.push("/dashboard")} type="button">
            Back to dashboard
          </NotFoundPrimaryButton>
        </NotFoundSectionSecondary>
      </NotFoundSection>
    </AppLayout>
  );
};
export default NotFoundPage;
